/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Dropdown, Icon, Input, Button, DatePicker, Table, LocaleProvider, message} from 'antd';
import Menu from 'antd/lib/menu';
import ui from '../../lang/ui.json';
import s from './Sent.css';
import {withRouter} from "react-router-dom";
import history from '../../history';

class Sent extends React.Component {
    _expandedRowKeys = new Set();

    static propTypes = {
        locale: PropTypes.objectOf(PropTypes.string).isRequired,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            data: [],
            visible: false,
            searchNumber: '',
            tempNumber: '',
            fromDate: '',
            toDate: '',
            clear: false,
            refreshIntervalId: '',
            expandedRowKeys: Array.from(this._expandedRowKeys.values()),
            config: require('Config'),
        };
    }

    componentDidMount() {
        this.onSearch(true);
        //this.setState({refreshIntervalId: setInterval(() => this.onSearch(false), 10000)});
    }

    componentWillUnmount() {
        clearInterval(this.state.refreshIntervalId)
    }

    onSearch(clearSearch) {
        var decode = require('iconv-lite').decode;
        fetch(this.state.config.serverUrl + 'search/onsearch?' +
            `${this.state.tempNumber && !clearSearch ? `&msisdn=${this.state.tempNumber}` : ''}` +
            `${this.state.fromDate ? `&fromDate=${this.state.fromDate}` : ''}` +
            `${this.state.toDate ? `&toDate=${this.state.toDate}` : ''}`,
            {
                headers: new Headers({
                    'Authorization': `Bearer ${sessionStorage.getItem("authenticationtoken")}`,
                    'username': `${sessionStorage.getItem('username')}`
                })
            })
            .then((response) => {
                if (response.status !== 200) {
                    this.errorMessage(response.statusText);
                }
                return response;
            })
            .then(response => response.json())
            .then(response => this.setState({data: response, clear: clearSearch}))
            .catch(error => this.errorMessage(error));
        this.setState({searchNumber: this.state.tempNumber});
    }

    toggleSearch() {
        this.setState({visible: !this.state.visible});
    }

    errorMessage = (error) => {
        message.error(`An error has occurred: ${error}`, 5);
    };

    _onExpand = (expanded, record) => {
        this._expandedRowKeys.has(record.transaction_id)
            ? this._expandedRowKeys.delete(record.transaction_id)
            : this._expandedRowKeys.add(record.transaction_id);

        this.setState({
            expandedRowKeys: Array.from(this._expandedRowKeys.values())
        });
    };

    render() {
        const columns = [{
            title: this.props.locale.tableDate,
            dataIndex: 'send_date',
            key: 'send_date',
            sorter: (a, b) => {
                if (a.send_date < b.send_date) return -1;
                if (a.send_date > b.send_date) return 1;
                return 0;
            },
            render: (text) => {
                var d = new Date(text);
                var options = {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                };
                return d.toLocaleDateString("en-GB", options);
            }
        },
            {
                title: this.props.locale.tableSender,
                dataIndex: 'used_anr',
                key: 'used_anr',
                render: (text) => {
                    if (!text) return 'Not sent';
                    return text;
                },
            },  {
                title: this.props.locale.tableMessageCount,
                dataIndex: 'destinations_count',
                key: 'destinations_count',
                sorter: (a, b) => {
                    if (a.ip < b.ip) return -1;
                    if (a.ip > b.ip) return 1;
                    return 0;
                },
            },
            {
                title: this.props.locale.status,
                dataIndex: 'id',
                key: 'id',
                render: (text, record, index) => {
                    let className = "";
                    if (record.destinations_count == record.successful) {
                        className = s.green;
                        text = this.props.locale.sendSuccess;
                    }
                    else if(record.destinations_count == record.failed) {
                        className = s.orange;
                        text = this.props.locale.sendFailure;
                    }
                    else if(record.failed + record.successful == record.destinations_count) {
                        className = s.orange;
                        text = this.props.locale.sendPartialSuccess;
                    }
                    else{
                        text = this.props.locale.sendProcessing;
                    }
                    return <span className={className}>{text}</span>
                },
            },
            {
                title: "",
                render: () => {
                    return <div className={s.tableMoreInfo}>
                        {this.props.locale.tableMore}
                    </div>;
                },
            }];
        const searchForm = (
            <Menu selectable={false}>
                <Menu.Item>
                    <div className={s.search}>
                        <div className={s.search_row}>
                            <Input
                                placeholder={this.props.locale.searchMSISDN}
                                value={this.state.tempNumber}
                                onChange={(event) => {
                                    this.setState({tempNumber: event.target.value});
                                }}
                                onPressEnter={() => {
                                    this.onSearch(false);
                                }}
                            />
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.onSearch(false);
                                }}
                            >{this.props.locale.searchButton}</Button>
                        </div>
                        <div className={s.search_row}>
                            <DatePicker
                                placeholder={this.props.locale.searchStart}
                                onChange={(event) => {
                                    this.setState({fromDate: moment(event).format('YYYY-MM-DD')});
                                }}
                            />
                            <DatePicker
                                placeholder={this.props.locale.searchEnd}
                                onChange={(event) => {
                                    this.setState({toDate: moment(event).format('YYYY-MM-DD')});
                                }}
                            />
                        </div>
                    </div>
                </Menu.Item>
            </Menu>
        );
        return (
            <LocaleProvider locale={ui}>
                <div className={s.root}>
                    <div className={s.headline}>
                        <h1>{this.props.locale.title}</h1>
                        <div className={s.headline_cont}>
                            <Dropdown
                                className={s.search}
                                placement="bottomRight"
                                overlay={searchForm}
                                trigger={['click']}
                                visible={this.state.visible}
                            >
                                <div>
                                    {this.state.searchNumber != '' ?
                                        <button
                                            role="button"
                                            className={s.search_clear}
                                            onClick={() => {
                                                this.setState({searchNumber: ''});
                                                this.setState({tempNumber: ''});
                                                this.onSearch(true);
                                                this.setState({clear: false});
                                            }}
                                        >Clear search</button>
                                        : ''}
                                    <Icon
                                        className={s.headline_icon}
                                        type="search"
                                        onClick={() => {
                                            this.toggleSearch();
                                        }}
                                    />
                                </div>
                            </Dropdown>
                        </div>
                    </div>
                    <Table
                        rowClassName={s.batchRow}
                        className={s.table}
                        columns={columns}
                        dataSource={this.state.data}
                        rowKey="transaction_id"
                        onRow={(record) => ({
                            onClick: () => {
                                history.push("/sent/" + record.id)
                            },
                        })}
                    />
                </div>
            </LocaleProvider>
        );
    }
}

export default withRouter(Sent);



// WEBPACK FOOTER //
// ./src/routes/sent/Sent.js